export default{
    newsTitle:"Industry news",
    newsRead:'Pageviews',

    newsTitle1:"Fintech loan interest fell by 50%, loan players were selective in choosing prospective borrowers",
    newsContent1:'KONTAN.CO.ID - JAKARTA. The Indonesian Joint Funding Association (AFPI) has agreed to cut the upper limit of the maximum online loan interest rate (pinjol) to approximately 50% of the daily loan interest rate of 0.8% maximum. ',
    

    newsTitle2:'SDB Presents Toko Score, a Digital-Based Credit Assessment Service',
    newsContent2:"The Bank Indonesia (BI) published its latest regulatory framework for the Fintech sector at the end of 2017. It is said to further encourage domestic financial innovation, but at the same time to protect users' information and financial stability, how can this contradiction be broken?",

    newsTitle3:"BNI Supports IPB Pushing for Campus Financial Ecosystem Acceleration",
    newsContent3:'Cash loan and consumer finance is really a big cake, attractive and delicious, a lot of capital bosses are also staring at this market, the competition is fierce, if not two brush, really can not play.',

    newsTitle4:"Able to Accelerate Credit Distribution, These are 4 Advantages of Credit Scoring",
    newsContent4:"As a result of the COVID-19 pandemic, which is still happening today, it was recorded that during 2020 credit distribution in Indonesia experienced a slowdown.",

    newsTitle5:'Cooking Data, Building "Credit Scoring"',
    newsContent5:'How a financial technology startup builds a customer "credit scoring" database',

    newsTitle6:"BRI's Efforts to Explore New Sources of Growth in the MSME Segment",
    newsContent6:'According to a new study by mobile app marketing firm Liftoff, financial apps will perform well in the global market in 2020, with 4.6 billion apps downloaded, up 15% from the previous year.',
}